const FEATURE_PREFIX = "navbar-revamp";

const ACCOUNTS_PREFIX = "accounts";
const CONNECTIONS_PREFIX = "connections";
const DISCOVER_PREFIX = "discover";
const DROPDOWN_OPTION_PREFIX = "dropdown-option";
const HOME_PREFIX = "home";
const PROFILE_PREFIX = "profile";
const REPORTING_PREFIX = "reporting";
const SHOP_PREFIX = "shop";
const TRIGGER_PREFIX = "trigger";
const WORKSPACES_PREFIX = "workspaces";

export const AccountsDropdownIds = {
  AccountsTrigger: `${FEATURE_PREFIX}__${ACCOUNTS_PREFIX}__${TRIGGER_PREFIX}`,
  AccountsOptionHelp: `${FEATURE_PREFIX}__${ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__help`,
  AccountsOptionLogout: `${FEATURE_PREFIX}__${ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__logout`,
  AccountsOptionSettings: `${FEATURE_PREFIX}__${ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__settings`,
  AccountsOptionSwitchTo: `${FEATURE_PREFIX}__${ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__switch_to`,
};

export const ConnectionsDropdownIds = {
  ConnectionOptionsManage: `${FEATURE_PREFIX}__${CONNECTIONS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__manage`,
  ConnectionOptionsRequests: `${FEATURE_PREFIX}__${CONNECTIONS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__requests`,
  ConnectionTrigger: `${FEATURE_PREFIX}__${CONNECTIONS_PREFIX}__${TRIGGER_PREFIX}`,
};

export const DiscoverDropdownIds = {
  DiscoverTrigger: `${FEATURE_PREFIX}__${DISCOVER_PREFIX}__${TRIGGER_PREFIX}`,
  DiscoverOptionFindNewBrands: `${FEATURE_PREFIX}__${DISCOVER_PREFIX}__${DROPDOWN_OPTION_PREFIX}__find_new_brands`,
  DiscoverOptionPassport: `${FEATURE_PREFIX}__${DISCOVER_PREFIX}__${DROPDOWN_OPTION_PREFIX}__passport`,
};

export const ShopDropdownIds = {
  ShopTrigger: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${TRIGGER_PREFIX}`,
  ShopOptionLooks: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__looks`,
  ShopOptionBrowseCatalog: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__browse_catalog`,
  ShopOptionCreateStyleboard: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__create_styleboard`,
  ShopOptionStyleBoards: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__styleboards`,
  ShopOptionLinesheets: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__linesheets`,
  ShopOptionStartOrder: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__start_order`,
};

export const HomeIds = {
  HomeLinkTrigger: `${FEATURE_PREFIX}__${HOME_PREFIX}__${TRIGGER_PREFIX}`,
};

export const ManageProfileIds = {
  ManageProfileTrigger: `${FEATURE_PREFIX}__${PROFILE_PREFIX}__${TRIGGER_PREFIX}`,
};

export const ReportingOptionIds = {
  ReportingTrigger: `${FEATURE_PREFIX}__${REPORTING_PREFIX}__${TRIGGER_PREFIX}`,
};

export const WorkspacesOptionIds = {
  WorkspacesTrigger: `${FEATURE_PREFIX}__${WORKSPACES_PREFIX}__${TRIGGER_PREFIX}`,
  WorkspacesOption: `${FEATURE_PREFIX}__${WORKSPACES_PREFIX}__${DROPDOWN_OPTION_PREFIX}__workspaces`,
  BrandNotesOption: `${FEATURE_PREFIX}__${WORKSPACES_PREFIX}__${DROPDOWN_OPTION_PREFIX}__brand_notes`,
  ArchivedOption: `${FEATURE_PREFIX}__${WORKSPACES_PREFIX}__${DROPDOWN_OPTION_PREFIX}__archived`,
};
